import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import SymptomsHero from './components/SymptomsHero';
import SymptomsGrid from './components/SymptomsGrid';

export default function SymptomsPage() {
  useSEO({
    title: 'CSCF Symptoms & Clinical Features | Cardiospondylocarpofacial Syndrome — CSCF Support',
    description:
      'Detailed overview of CSCF symptoms and clinical features: cardiac defects, skeletal fusions, conductive hearing loss, developmental delays, and craniofacial features. Based on peer-reviewed research.',
    keywords:
      'CSCF symptoms, Cardiospondylocarpofacial syndrome features, CSCF cardiac defects, CSCF hearing loss, CSCF skeletal fusions, MAP3K7 symptoms, rare disease symptoms, CSCF clinical features',
    canonical: 'https://cscfsupport.org/symptoms',
    ogImage: SOCIAL_IMAGE,
    breadcrumbs: [
      { name: 'Home', url: 'https://cscfsupport.org/' },
      { name: 'CSCF Symptoms', url: 'https://cscfsupport.org/symptoms' },
    ],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'MedicalWebPage',
      name: 'CSCF Symptoms & Clinical Features',
      url: 'https://cscfsupport.org/symptoms',
      description:
        'Comprehensive overview of Cardiospondylocarpofacial syndrome (CSCF) symptoms including cardiac, skeletal, hearing, developmental, and craniofacial features.',
      about: {
        '@type': 'MedicalCondition',
        name: 'Cardiospondylocarpofacial Syndrome',
        alternateName: ['CSCF', 'CSCFS'],
        signOrSymptom: [
          { '@type': 'MedicalSymptom', name: 'Congenital heart defects' },
          { '@type': 'MedicalSymptom', name: 'Vertebral fusions' },
          { '@type': 'MedicalSymptom', name: 'Bilateral conductive hearing loss' },
          { '@type': 'MedicalSymptom', name: 'Developmental delay' },
          { '@type': 'MedicalSymptom', name: 'Short stature' },
          { '@type': 'MedicalSymptom', name: 'Craniofacial features' },
        ],
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <SymptomsHero />
      <SymptomsGrid />
      <Footer />
    </div>
  );
}
